// Cognito User Types
export interface CognitoUserAttributes {
  email: string;
  email_verified?: boolean;
  name?: string;
  picture?: string; // Google avatar URL
  sub: string;
}

export interface AuthUser {
  username: string;
  userId: string;
  signInDetails?: {
    loginId?: string;
    authFlowType?: string;
  };
}

// App User Type (derived from Cognito attributes)
export interface User {
  id: string;
  email: string;
  name: string;
  avatar: string;
  groups: string[];
}

// Allowed Cognito groups for app access
export const ALLOWED_GROUPS = ['Users', 'Admins'] as const;
export type AllowedGroup = typeof ALLOWED_GROUPS[number];

// Stream Types
export type SeekOption = '-1h' | '-3h' | '-6h' | '-12h' | '-24h' | '-48h' | '-72h';

export interface StreamState {
  isPlaying: boolean;
  isMuted: boolean;
  isLive: boolean;
  currentSeek: SeekOption | null;
  volume: number;
}
